import "core-js/modules/es6.object.assign";
import _toConsumableArray from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/inherits";
import { duplicate, hash as _hash, unique } from '../../util';
import { DataFlowNode } from './dataflow';
/**
 * A class for pivot transform nodes.
 */

export var PivotTransformNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(PivotTransformNode, _DataFlowNode);

  function PivotTransformNode(parent, transform) {
    var _this;

    _classCallCheck(this, PivotTransformNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PivotTransformNode).call(this, parent));
    _this.transform = transform;
    return _this;
  }

  _createClass(PivotTransformNode, [{
    key: "clone",
    value: function clone() {
      return new PivotTransformNode(null, duplicate(this.transform));
    }
  }, {
    key: "addDimensions",
    value: function addDimensions(fields) {
      var _a;

      this.transform.groupby = unique(((_a = this.transform.groupby) !== null && _a !== void 0 ? _a : []).concat(fields), function (d) {
        return d;
      });
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return undefined; // return undefined so that potentially everything can depend on the pivot
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      var _a;

      return new Set([this.transform.pivot, this.transform.value].concat(_toConsumableArray((_a = this.transform.groupby) !== null && _a !== void 0 ? _a : [])));
    }
  }, {
    key: "hash",
    value: function hash() {
      return "PivotTransform ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var _this$transform = this.transform,
          pivot = _this$transform.pivot,
          value = _this$transform.value,
          groupby = _this$transform.groupby,
          limit = _this$transform.limit,
          op = _this$transform.op;
      return Object.assign(Object.assign(Object.assign({
        type: 'pivot',
        field: pivot,
        value: value
      }, limit !== undefined ? {
        limit: limit
      } : {}), op !== undefined ? {
        op: op
      } : {}), groupby !== undefined ? {
        groupby: groupby
      } : {});
    }
  }]);

  return PivotTransformNode;
}(DataFlowNode);